import { render } from "./school-icon.vue?vue&type=template&id=4ab91ba1"
import script from "./school-icon.vue?vue&type=script&lang=js"
export * from "./school-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__